import baseApi from "../api/baseApi";

const authApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    loginAdmin: builder.mutation({
      query: (payload) => ({
        url: "/auth/login/staff",
        method: "POST",
        credentials: "include",
        body: payload,
      }),
    }),
    logoutAdmin: builder.query({
      query: () => ({
        url: "/auth/logout",
        method: "GET",
        credentials: "include",
      }),
    }),
  }),
});

export const { useLoginAdminMutation, useLogoutAdminQuery, useLazyLogoutAdminQuery } = authApi;
